import * as React from "react";
import { MapsProps, MapsInjectedProps } from "../typings";
import ModuleMap, { MapContext } from "../ModuleMap";
import { inject, observer } from "mobx-react";
import { withLocalization } from "bernie-l10n";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { classNames } from "uitk-react-utils";
import { UitkLoader } from "uitk-react-loader";

const isInViewport = (element: HTMLDivElement): boolean => {
  const distance = element.getBoundingClientRect();
  if (!distance) {
    return false;
  }

  return (
    distance.bottom > (window.innerHeight || document.documentElement.clientHeight) &&
    distance.top < (window.innerHeight || document.documentElement.clientHeight)
  );
};

const DynamicMaps: React.FC<MapsProps> = (props: MapsProps & MapsInjectedProps) => {
  const { staticMap, flexComponent, context } = props;
  const shouldOpenMapInSRP = false;
  const sendUserToSRP = false;
  const toggleShowFullscreenMap = () => null;
  const countryCode = (context && context.site && context.site.country) || "";
  const elemRef = React.useRef<HTMLDivElement | null>(null);
  const placeHolderAltText =
    (context &&
      context.searchContext &&
      context.searchContext.location &&
      context.searchContext.location.extendedName) ||
    "";

  if (typeof window === "undefined") {
    staticMap.generateGooglePlaceHolderMapImage(context, countryCode);
  }

  const [isLoaderVisible, showLoader] = React.useState(true);

  const [isBottomSheetSticky, setBottomSheetPosition] = React.useState(true);

  // Handler anchoring bottom sheet to the bottom of the window
  React.useEffect(() => {
    const viewportSizeCheck = () => {
      setBottomSheetPosition(isInViewport(elemRef.current as HTMLDivElement));
    };
    window.addEventListener("scroll", viewportSizeCheck);

    return () => window.removeEventListener("scroll", viewportSizeCheck);
  }, []);

  const toggleLoader = () => {
    showLoader(!isLoaderVisible);
  };

  return (
    <div
      className="Maps uitk-flex uitk-cell all-cell-1-1 all-y-padding-three"
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
        {staticMap && staticMap.signedPlaceHolderUrl && (
          <UitkImage alt={placeHolderAltText} src={staticMap.signedPlaceHolderUrl} data-testid="placeholder-map" />
        )}
        {isLoaderVisible && <UitkLoader className="dynamicMapLoader" />}
        <div ref={elemRef} className={classNames("uitk-flex dynamicMap")} data-testid="dynamic-map">
          <MapContext.Provider
            value={{
              toggleShowFullscreenMap,
              sendUserToSRP,
              shouldOpenMapInSRP
            }}
          >
            <ModuleMap
              {...props}
              classNames={classNames(
                "uitk-dialog-content uitk-dynamic-map",
                isBottomSheetSticky && "setStickyBottomSheet"
              )}
              onMapMounted={toggleLoader}
              isDynamic={true}
            />
          </MapContext.Provider>
        </div>
      </UitkFigure>
    </div>
  );
};

export const Maps = withLocalization<MapsProps, React.FC<MapsProps>>(
  inject("analytics", "hotels", "staticMap", "context", "poi")(observer(DynamicMaps))
);

Maps.displayName = "DynamicMaps";

export default Maps;
